export default "__VITE_ASSET__C$VA8Lvv__"